import "core-js/modules/web.dom.iterable.js";
import React from 'react';
import classNames from 'classnames/bind';
import { useHeaderObserver } from '@thd-olt-functional/utils';
import { Sticky } from './Sticky';
const StickyWithHeaderObserver = _ref => {
  let {
    animation,
    boxShadow,
    children,
    className,
    forwardRef,
    offsetMargin,
    offsetScroll,
    position,
    stickyType,
    stickyByDefault,
    visibleByDefault
  } = _ref;
  const [entry] = useHeaderObserver();
  let headerOffset = 0;
  if (position === 'bottom') {
    var _entry$navigation, _entry$navigation$cli;
    headerOffset = entry !== null && entry !== void 0 && entry.visible && entry !== null && entry !== void 0 && (_entry$navigation = entry.navigation) !== null && _entry$navigation !== void 0 && _entry$navigation.positionBottom ? entry === null || entry === void 0 ? void 0 : (_entry$navigation$cli = entry.navigation.clientRect) === null || _entry$navigation$cli === void 0 ? void 0 : _entry$navigation$cli.height : 0;
  } else if (position === 'top') {
    var _entry$root, _entry$root$clientRec;
    headerOffset = entry !== null && entry !== void 0 && entry.visible ? entry === null || entry === void 0 ? void 0 : (_entry$root = entry.root) === null || _entry$root === void 0 ? void 0 : (_entry$root$clientRec = _entry$root.clientRect) === null || _entry$root$clientRec === void 0 ? void 0 : _entry$root$clientRec.height : 0;
  }
  const calculatedOffset = offsetMargin + headerOffset;
  const stickyClassNames = classNames(className, {
    'sui-transition-[bottom]': position === 'bottom',
    'sui-transition-[top]': position === 'top',
    '!sui-duration-500': headerOffset > 0
  });
  return /*#__PURE__*/React.createElement(Sticky, {
    animation: animation,
    boxShadow: boxShadow,
    className: stickyClassNames,
    forwardRef: forwardRef,
    offsetMargin: calculatedOffset,
    offsetScroll: offsetScroll,
    position: position,
    stickyType: stickyType,
    stickyByDefault: stickyByDefault,
    visibleByDefault: visibleByDefault
  }, children);
};
StickyWithHeaderObserver.displayName = 'StickyWithHeaderObserver';
StickyWithHeaderObserver.propTypes = Sticky.propTypes;
StickyWithHeaderObserver.defaultProps = Sticky.defaultProps;
export { StickyWithHeaderObserver };
//# sourceMappingURL=StickyWithHeaderObserver.js.map